export default "<body>\n    <div class=\"nav\">\n        <navbar-admin></navbar-admin>\n    </div>\n    \n    <router-outlet></router-outlet>    \n</body>\n"